import getIdToken from '../components/getIdToken';

const addUserToBackendIfFirstTime = async (firebaseUid, email, refreshCredits) => {
    try {
        const idToken = await getIdToken();
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}xeo/v1/user`, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${idToken}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                firebaseUid,
                email,
            }),
        });

        if (!response.ok) {
            const errorData = await response.json();
            console.error('Failed to create user:', errorData.message || response.statusText);
        } else {
            const data = await response.json();

            if (data.existed === true) {
                // Don't show free credits dialog for existing users
            } else {

                // Call the free credit endpoint
                const freeCreditResponse = await fetch(`${process.env.REACT_APP_API_BASE_URL}xeo/v1/user/${firebaseUid}/freeCredit`, {
                    method: 'POST',
                    headers: {
                        Authorization: `Bearer ${idToken}`,
                        'Content-Type': 'application/json',
                    },
                });


                if (freeCreditResponse.ok) {
                    if (freeCreditResponse.status !== 204) {
                        const freeCreditData = await freeCreditResponse.json();
                    } else {
                    }

                    // ✅ SET THE FLAG FOR NEW USERS WHO RECEIVE FREE CREDITS
                    sessionStorage.setItem('receivedFreeCredits', 'true');

                    // Refresh credits after a delay
                    setTimeout(() => {
                        refreshCredits();
                    }, 1500);
                } else {
                    console.error('Failed to give free credits:', freeCreditResponse.status);
                }
            }
        }
    } catch (err) {
        console.error('Error adding user to backend:', err.message);
    }
};

export default addUserToBackendIfFirstTime;